module.exports = __webpack_public_path__ + "img/23646030000175.302290d4.png";